import SearchIcon from '@mui/icons-material/Search';
import { Badge, Button, InputAdornment, Stack, TextField } from '@mui/material';
import { GridToolbarColumnsButton, GridToolbarDensitySelector } from '@mui/x-data-grid';
import Iconify from 'src/components/iconify';

type HomeBannersTableToolbarProps = {
  searchText: string;
  selectedFiltersCount: number;
  handleClickFilters: () => void;
  setSearchText: (value: string) => void;
};

export function HomeBannersTableToolbar({
  searchText,
  selectedFiltersCount,
  handleClickFilters,
  setSearchText,
}: HomeBannersTableToolbarProps) {
  return (
    <Stack direction="row" justifyContent="space-between" width="100%">
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          placeholder="Pesquisar..."
          variant="standard"
          size="small"
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" sx={{ color: 'text.primary' }} />
              </InputAdornment>
            ),
            disableUnderline: false,
          }}
          sx={{
            minWidth: 250,
            '& input': {
              color: 'text.primary',
              opacity: 0.8,
            },
          }}
        />
      </Stack>

      <Stack direction="row" spacing={0.5}>
        <Button
          size="small"
          startIcon={
            <Badge
              color="primary"
              badgeContent={selectedFiltersCount}
              invisible={selectedFiltersCount === 0}
              overlap="circular"
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              sx={{
                '& .MuiBadge-badge': {
                  minWidth: 20,
                  height: 20,
                  fontSize: '0.65rem',
                  padding: '0 4px',
                },
              }}
            >
              <Iconify icon="mdi:filter-variant" />
            </Badge>
          }
          onClick={handleClickFilters}
        >
          Filtros
        </Button>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
      </Stack>
    </Stack>
  );
}
